jQuery( function($){

    var $images = $('img');
    var image_count = $images.length;
    var images_loaded = 0;
    var $bar = $('.animLogo__bar');
    var $header = $('.site-header');
    var $controls = $('.animControls');
    
    if(!$('.anim').length){
        return;
    }

    $('body, html').scrollTop(0);

    $images.each(function (i,el){
        var newImg = new Image();
        newImg.onload = oneImageLoaded;
        newImg.src = el.src;
    });

    function oneImageLoaded(){
        images_loaded ++;
        $bar.css('width', (images_loaded / image_count * 100) + '%');

        if( images_loaded >= image_count ){
            go();
        }
    }

    function go(){
        setupFirstBlock();
        startLogoAnimation();
    }

    function startLogoAnimation(){

        $bar.fadeOut(200);
        var letter_duration = 1.3;
        var remove_duration = 0.6;
        var animLogoTL = new gsap.timeline();
        animLogoTL
            .to('.animLogo__letter.--o',{y : 0, duration: letter_duration}, 0)
            .to('.animLogo__letter.--s',{y : 0, duration: letter_duration}, '<0.1')
            .to('.animLogo__letter.--a',{y : 0, duration: letter_duration}, '<0.1')
            .to('.animLogo__letter.--l',{y : 0, duration: letter_duration}, '<0.1')
            .to('.animLogo__letter.--r',{y : 0, duration: letter_duration}, '<0.1')
            .to('.animLogo',{y:'-100vh', duration: remove_duration}, '>+1');

        setTimeout( enableScroll,(letter_duration + remove_duration) * 1000 + 400 );
    }

    function enableScroll(){
        $('body, html')
            .scrollTop(0)
            .removeClass('no-scroll');
    }

    function setupFirstBlock(){
        var tl = newTimeline('.anim');

        tl
            // Imagen
            .to('.animImg__dot',{scale:1, opacity: 1, duration: 1, onStart: removeMultiply, onReverseComplete: addMultiply })

            // Sol
            .to('.animSol',{opacity:1, duration: 0.2})

            // Puntito se achica y gira
            .to('.animSol__dot',{scaleX:9.3,scaleY:0.2,duration: 0.5, onStart: function (){
                    addMenuOptions();
                    showControls();
                }, onReverseComplete: function(){
                    removeMenuOptions();
                    hideControls();
                } })
            .to('.animSol__dot',{rotate: 360, duration: 2})

            // Puntito se transforma en la O
            .to('.animSol__word', {opacity:1,duration:0.01})
            .to('.animSol__dot', {opacity:0,duration:0.01},'<')
            .to('.animSol__word', {scaleY:1, duration: 1}, '<')

            // Aparecen las letras
            .to('.animSol__letter.--s', {x:0, opacity: 1, duration: 1})
            .to('.animSol__letter.--l', {x:0, opacity: 1, duration: 1}, '<')

            // Se va la S y la L
            .to('.animSol__letter.--s', {x:'-500%', opacity: 0, duration: 1}, '>+0.5')
            .to('.animSol__letter.--l', {x:'500%', opacity: 0, duration: 1}, '<')

            // La O Crece y aparece el texto
            .to('.animSol__o', {scale: 3, duration: 1}, '<')
            .to('.animSol__o-dot', {scale: 0, opacity: 0, duration: 1}, '<')
            .to('.animSol__text', {scale: 1, opacity: 1, duration: 1}, '<+0.5')

            // La O se queda fija y se encoge
            .to('.animSol__o',{scale: 0, duration: 2})
            .to('.animSol__text',{scale: 0, duration: 2}, '<')

            // Sube el siguiente bloque de elementos
            .to('.anim__below',{y:0, duration: 2},'<')

            // Letras de suelo
            .to('.letter-0',{y:0,opacity: 1, duration: 2}, '<')
            .to('.letter-1',{y:0,opacity: 1, duration: 1}, '<+0.5')
            .to('.letter-2',{y:0,opacity: 1, duration: 1}, '<+0.5')
            .to('.letter-3',{y:0,opacity: 1, duration: 1}, '<+0.5')
            .to('.letter-4',{y:0,opacity: 1, duration: 1}, '<+0.5')

            // Se mueve el fondo
            .to('.animSuelo__bg',{y:'-50%',duration: 3})
            .to('.animSuelo__title',{opacity: 0, y:'-50%', duration: 3}, '<')
            .to('.animSuelo__text',{opacity: 1, y: 0, duration: 3},'<')

            // Se va Suelo y entra Logo Zoom
            .to('.animSuelo',{x:'100%',duration: 1.5})
            .to('.animSuelo__bg',{x:'-100%',duration: 1.5},'<')
            .to('.animSuelo__title',{x:'-100%',duration: 1.5},'<')
            .to('.animSuelo__text',{x:'-100%',duration: 1.5, onStart: headerRedOnWhite, onReverseComplete: headerWhiteOnRed},'<')


            .to('.animLogoZoom__letter.--s',{y:0,duration: 0.5}, '<')
            .to('.animLogoZoom__letter.--o',{y:0,duration: 0.5}, '<+0.2')
            .to('.animLogoZoom__letter.--l',{y:0,duration: 0.5}, '<+0.2')
            .to('.animLogoZoom__letter.--a',{y:0,duration: 0.5}, '<+0.2')
            .to('.animLogoZoom__letter.--r',{y:0,duration: 0.5}, '<+0.2')

            .to('.animLogoZoom__word', {x:'350%', y:'-470%', scale :20, opacity: 0, duration: 1 } )
            .to('.animLogoZoom__text', {scale: 1, opacity: 1, duration: 1}, '<+0.5')

            // Entran AnimBlocks y los bloques que están en distintas posiciones
            .to('.animBlocks', {opacity: 1, duration: 1, onStart: headerSolidBg, onReverseComplete:headerTransparent}, '<+0.5')
            .to('.animLogoZoom__text', {scale: 2, opacity: 0, duration: 1}, '<+0.3')

            // Aparecen los bloques y el texto
            .to('.animBlocks__content',{x:0, duration: 1, opacity: 1}, '<+0.5')
            .to('.animBlocks__text',{x:0, duration: 1}, '<+0.5')

            // Aparecen las imágenes
            .to('.animBlocks__img',{x:0, duration: 1}, '>+0.5')

            // Desaparecen los bloques y aparece el "preview"
            .to('.animBlocks', {scale: 0, opacity: 0, duration: 1})
            .call(function(){ $('.preview').addClass('pointer-on')},[], '<')

            // Entrada de preview
            .to('.preview__top',{y:0, scale: 1, opacity: 1, duration: 1, onStart: hideControls, onReverseComplete: showControls }, '<0.5')
            .to('.preview__group', {x:0, y: 0, scale: 1, opacity: 1, duration: 1}, '<')
            // Fake
            .to('.preview',{x:0, duration: 0.5});


    }

    function removeMultiply(){
        $header.removeClass('bg-multiply').addClass('bg-transparent');
    }
    function addMultiply(){
        $header.addClass('bg-multiply').removeClass('bg-transparent');
    }

    function headerWhiteOnRed(){
        $header.attr('data-bg', 'red');
        $controls.removeClass('color-red');
    }
    function headerRedOnWhite(){
        $header.attr('data-bg', 'white');
        $controls.addClass('color-red');
    }

    function addMenuOptions(){
        $header.removeClass('hide-options');
    }
    function removeMenuOptions(){
        $header.addClass('hide-options');
    }

    function headerSolidBg(){
        $header.removeClass('bg-transparent');
    }
    function headerTransparent(){
        $controls.removeClass('is-off');
        $header.addClass('bg-transparent');
    }

    function hideControls(){
        $controls.addClass('is-off');
    }
    function showControls(){
        $controls.removeClass('is-off');
    }

    function newTimeline(trigger,start,end, pin){

        start = typeof start === 'undefined' ? 'top top' : start;
        end = typeof end === 'undefined' ? 'bottom bottom' : end;
        pin = typeof pin === 'undefined' ? true : pin;

        return new gsap.timeline({
            scrollTrigger: {
                trigger : trigger,
                start : start,
                end : end,
                scrub : 1,
                pin : pin ? pin : false
            }
        });
    }

});